import Chart from "chart.js/auto";

const elem = document.getElementById("myChart");
if (elem) {
  const ctx = elem.getContext("2d");
  const myChart = new Chart(ctx, {
    type: "line",
    data: {
      labels: [
        "3/19",
        "6/19",
        "9/19",
        "12/19",
        "3/20",
        "6/20",
        "9/20",
        "12/20",
        "3/21",
        "6/21",
        "9/21",
        "12/21",
        "3/22",
        "6/22",
        "9/22",
        "12/22"
      ],
      datasets: [
        {
          label: elem.dataset.label,
          data: [
            1.008,
            1.03,
            1.038,
            1.061,
            1.083,
            1.091,
            1.1143,
            1.14,
            1.16,
            1.1869,
            1.2093,
            1.23,
            1.25,
            1.27,
            1.295,
            1.316
          ],
          backgroundColor: ["rgb(236 110 134)"],
          borderColor: ["rgb(111 207 151)"],
          borderWidth: 3
        }
      ]
    },
    options: {
      animations: {
        x: {
          duration: 600,
          easing: "linear"
        },
        y: {
          duration: 1000,
          easing: "linear"
        }
      },
      scales: {
        y: {
          beginAtZero: false,
          title: {
            display: true,
            text: elem.dataset.yAxis,
            align: "end"
          },
          grid: {
            display: false
          }
        },
        x: {
          title: {
            display: true,
            text: elem.dataset.xAxis,
            align: "end"
          },
          grid: {
            display: true
          }
        }
      },
      plugins: {
        deferred: {
          xOffset: 150, // defer until 150px of the canvas width are inside the viewport
          yOffset: "50%", // defer until 50% of the canvas height are inside the viewport
          delay: 10500 // delay of 500 ms after the canvas is considered inside the viewport
        },
        tooltip: {
          enabled: false
        }
      }
    }
  });
}
